'use client';

import classNames from 'classnames';
import type { StaticImageData } from 'next/image';
import { useState } from 'react';
import Image from '@alltrails/core/components/Image';
import { useLanguageRegionCode } from '@alltrails/core/hooks/useLanguageRegionCode';
import type { LanguageCode } from '@alltrails/types/LanguageCode';
import VimeoFacadeDe from '../../assets/images/vimeo-facade-v2-de.avif';
import VimeoFacadeEn from '../../assets/images/vimeo-facade-v2-en.avif';
import VimeoFacadeEs from '../../assets/images/vimeo-facade-v2-es.avif';
import VimeoFacadeFR from '../../assets/images/vimeo-facade-v2-fr.avif';
import styles from './styles/OurCulture.module.scss';

const videoMap: { lang: LanguageCode; id: string; src: StaticImageData }[] = [
  { lang: 'en', id: '857511762?h=0d541fd038', src: VimeoFacadeEn },
  { lang: 'fr', id: '689475312?h=9683202939', src: VimeoFacadeFR },
  { lang: 'de', id: '689475103?h=69db207e1d', src: VimeoFacadeDe },
  { lang: 'da', id: '857511762?h=0d541fd038', src: VimeoFacadeEn },
  { lang: 'nl', id: '857511762?h=0d541fd038', src: VimeoFacadeEn },
  { lang: 'it', id: '857511762?h=0d541fd038', src: VimeoFacadeEn },
  { lang: 'nb', id: '857511762?h=0d541fd038', src: VimeoFacadeEn },
  { lang: 'pl', id: '857511762?h=0d541fd038', src: VimeoFacadeEn },
  { lang: 'pt', id: '857511762?h=0d541fd038', src: VimeoFacadeEn },
  { lang: 'es', id: '689475490?h=3540b9b727', src: VimeoFacadeEs },
  { lang: 'sv', id: '857511762?h=0d541fd038', src: VimeoFacadeEn }
];

const Video = ({ title }) => {
  const [display, setDisplay] = useState(false);
  const languageCode = useLanguageRegionCode();
  const languageSplit = languageCode.split('-');
  const currentVideo = videoMap.find(video => video.lang === languageSplit[0]);

  return (
    <>
      {display ? (
        <>
          <div className={styles.embedFlex}>
            <div className={styles.embedContainer}>
              <iframe
                title={title}
                src={`https://player.vimeo.com/video/${currentVideo?.id}&color=428A13&title=0&byline=0&portrait=0&autoplay=true`}
                className={styles.embedVid}
                frameBorder="0"
                allow="autoplay; fullscreen; picture-in-picture"
                allowFullScreen
              />
            </div>
          </div>
          <script src="https://player.vimeo.com/api/player.js" async />
        </>
      ) : (
        <button type="button" aria-label={title} className={classNames(styles.embedFlex, styles.buttonReset)} onClick={() => setDisplay(true)}>
          <div className={styles.embedContainer}>
            <Image className={styles.embedVid} src={currentVideo?.src} alt={title} fill />
          </div>
        </button>
      )}
    </>
  );
};

export default Video;
